import keyBy from "lodash/keyBy";

import { ORDER_SERVICE_API_URL } from "@stadium/services/axios";
import { jsonDataFormatter } from "@stadium/helpers/formatter";
import { getCountriesWithAdditionalData } from "@stadium/helpers/country/utils";
import { US_COUNTRY } from "@stadium/constants/country";

const emptyObj = {};

export const fetchConfig = async (configPayload) =>
  fetch(`${ORDER_SERVICE_API_URL}/config?${new URLSearchParams(configPayload)}`, {
    method: "GET",
    next: {
      tags: ["sbs-config"],
    },
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Failed to fetch config");
      }
      return res.json();
    })
    .then((res) => {
      const formattedResponse = jsonDataFormatter(JSON.parse(res));
      const unformattedConfigData = formattedResponse?.config?.configId || emptyObj;
      const spreeTaxons = formattedResponse?.spreeTaxons;
      const spreeZones = Object.values(formattedResponse?.spreeZones || emptyObj);
      const zonesMapping = formattedResponse?.spreeZones;
      const usCountryId = unformattedConfigData.countries.find(
        ({ iso }) => iso.toLowerCase() === US_COUNTRY.iso.toLowerCase(),
      )?.id;
      const configData = {
        ...getCountriesWithAdditionalData({
          configData: unformattedConfigData,
          zonesData: keyBy(spreeZones, "uniqCountryId"),
        }),
        spreeTaxons,
        spreeZones,
        defaultAskForPreferenceMessage: unformattedConfigData.defaultAskForPreferenceMessage,
        usCountryId,
        zonesMapping,
      };
      return configData;
    })
    .catch((error) => {
      throw error;
    });
